import { AlertTriangle, RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";

const AppErrorState = ({
  title = "Une erreur est survenue",
  message = "Service indisponible, réessayez",
  hint = null,
  actionLabel = "Réessayer",
  onAction = null,
  onRetry = null,
  fullScreen = false,
  className = "",
  testId,
}) => {
  const actionHandler = onAction || onRetry;

  return (
    <section
      className={`${fullScreen ? "min-h-screen flex items-center justify-center p-4 sm:p-6" : ""} ${className}`.trim()}
      data-testid={testId}
    >
      <div
        className={`w-full rounded-3xl border border-red-500/20 p-6 ${
          fullScreen
            ? "max-w-xl bg-red-500/10"
            : "bg-red-500/5"
        }`}
      >
        <div
          className={`flex flex-col gap-4 ${
            fullScreen ? "items-center text-center" : "md:flex-row md:items-start md:justify-between"
          }`}
        >
          <div className={`flex ${fullScreen ? "flex-col items-center text-center" : "gap-3"}`}>
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-red-500/10 text-red-300">
              <AlertTriangle className="h-5 w-5" />
            </div>
            <div>
              <p className="text-sm font-semibold text-white">{title}</p>
              <p className="mt-1 text-sm text-red-200">{message}</p>
              {hint ? (
                <p className="mt-2 text-sm text-slate-400">{hint}</p>
              ) : null}
            </div>
          </div>

          {actionHandler ? (
            <Button
              type="button"
              variant="outline"
              onClick={actionHandler}
              className="border-white/10 bg-white/[0.03] text-slate-200 hover:border-lenvia-blue/30 hover:bg-lenvia-blue/10 hover:text-white"
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              {actionLabel}
            </Button>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default AppErrorState;
